import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  GLOBAL_STATE,
  LESSON,
  LESSON_ALL,
  LESSON_ASSESSMENT,
  LESSON_ASSESSMENT_ALL,
  LESSON_ASSESSMENT_LIST,
  LESSON_ATTENDANCE,
  LESSON_ATTENDANCE_GROUP,
  LESSON_CREATE,
  LESSON_DELETE,
  LESSON_DISTANCE_LEARNING_ALL,
  LESSON_DOWNLOAD_FILES,
  LESSON_HOMEWORK_UPLOAD,
  LESSON_LIST,
  LESSON_MARK_ASSESSMENT,
  LESSON_SORTING,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const LESSONS = GLOBAL_STATE

const lossonsSlice = createSlice({
  name: LESSONS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.lesson.pending, state => {
        state[LESSON].loading = true
      })
      .addCase(actionCreators.lesson.rejected, (state, action) => {
        state[LESSON].loading = false
        state[LESSON].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lesson.fulfilled, (state, action) => {
        state[LESSON].loading = false
        state[LESSON].error = null
        state[LESSON].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonAll.pending, state => {
        state[LESSON_ALL].loading = true
      })
      .addCase(actionCreators.lessonAll.rejected, (state, action) => {
        state[LESSON_ALL].loading = false
        state[LESSON_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonAll.fulfilled, (state, action) => {
        state[LESSON_ALL].loading = false
        state[LESSON_ALL].error = null
        state[LESSON_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonAssessment.pending, state => {
        state[LESSON_ASSESSMENT].loading = true
      })
      .addCase(actionCreators.lessonAssessment.rejected, (state, action) => {
        state[LESSON_ASSESSMENT].loading = false
        state[LESSON_ASSESSMENT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonAssessment.fulfilled, (state, action) => {
        state[LESSON_ASSESSMENT].loading = false
        state[LESSON_ASSESSMENT].error = null
        state[LESSON_ASSESSMENT].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonAssessmentAll.pending, state => {
        state[LESSON_ASSESSMENT_ALL].loading = true
      })
      .addCase(actionCreators.lessonAssessmentAll.rejected, (state, action) => {
        state[LESSON_ASSESSMENT_ALL].loading = false
        state[LESSON_ASSESSMENT_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonAssessmentAll.fulfilled, (state, action) => {
        state[LESSON_ASSESSMENT_ALL].loading = false
        state[LESSON_ASSESSMENT_ALL].error = null
        state[LESSON_ASSESSMENT_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonAssessmentList.pending, state => {
        state[LESSON_ASSESSMENT_LIST].loading = true
      })
      .addCase(actionCreators.lessonAssessmentList.rejected, (state, action) => {
        state[LESSON_ASSESSMENT_LIST].loading = false
        state[LESSON_ASSESSMENT_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonAssessmentList.fulfilled, (state, action) => {
        state[LESSON_ASSESSMENT_LIST].loading = false
        state[LESSON_ASSESSMENT_LIST].error = null
        state[LESSON_ASSESSMENT_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonCreate.pending, state => {
        state[LESSON_CREATE].loading = true
      })
      .addCase(actionCreators.lessonCreate.rejected, (state, action) => {
        state[LESSON_CREATE].loading = false
        state[LESSON_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonCreate.fulfilled, (state, action) => {
        state[LESSON_CREATE].loading = false
        state[LESSON_CREATE].error = null
        state[LESSON_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonDelete.pending, state => {
        state[LESSON_DELETE].loading = true
      })
      .addCase(actionCreators.lessonDelete.rejected, (state, action) => {
        state[LESSON_DELETE].loading = false
        state[LESSON_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonDelete.fulfilled, (state, action) => {
        state[LESSON_DELETE].loading = false
        state[LESSON_DELETE].error = null
        state[LESSON_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonHomeworkUpload.pending, state => {
        state[LESSON_HOMEWORK_UPLOAD].loading = true
      })
      .addCase(actionCreators.lessonHomeworkUpload.rejected, (state, action) => {
        state[LESSON_HOMEWORK_UPLOAD].loading = false
        state[LESSON_HOMEWORK_UPLOAD].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonHomeworkUpload.fulfilled, (state, action) => {
        state[LESSON_HOMEWORK_UPLOAD].loading = false
        state[LESSON_HOMEWORK_UPLOAD].error = null
        state[LESSON_HOMEWORK_UPLOAD].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonList.pending, state => {
        state[LESSON_LIST].loading = true
      })
      .addCase(actionCreators.lessonList.rejected, (state, action) => {
        state[LESSON_LIST].loading = false
        state[LESSON_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonList.fulfilled, (state, action) => {
        state[LESSON_LIST].loading = false
        state[LESSON_LIST].error = null
        state[LESSON_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonMarkAssessment.pending, state => {
        state[LESSON_MARK_ASSESSMENT].loading = true
      })
      .addCase(actionCreators.lessonMarkAssessment.rejected, (state, action) => {
        state[LESSON_MARK_ASSESSMENT].loading = false
        state[LESSON_MARK_ASSESSMENT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonMarkAssessment.fulfilled, (state, action) => {
        state[LESSON_MARK_ASSESSMENT].loading = false
        state[LESSON_MARK_ASSESSMENT].error = null
        state[LESSON_MARK_ASSESSMENT].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonSorting.pending, state => {
        state[LESSON_SORTING].loading = true
      })
      .addCase(actionCreators.lessonSorting.rejected, (state, action) => {
        state[LESSON_SORTING].loading = false
        state[LESSON_SORTING].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonSorting.fulfilled, (state, action) => {
        state[LESSON_SORTING].loading = false
        state[LESSON_SORTING].error = null
        state[LESSON_SORTING].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonDownloadFiles.pending, state => {
        state[LESSON_DOWNLOAD_FILES].loading = true
      })
      .addCase(actionCreators.lessonDownloadFiles.rejected, (state, action) => {
        state[LESSON_DOWNLOAD_FILES].loading = false
        state[LESSON_DOWNLOAD_FILES].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonDownloadFiles.fulfilled, (state, action) => {
        state[LESSON_DOWNLOAD_FILES].loading = false
        state[LESSON_DOWNLOAD_FILES].error = null
        state[LESSON_DOWNLOAD_FILES].data = action.payload
      })

    builder
      .addCase(actionCreators.disLearningLessonAll.pending, state => {
        state[LESSON_DISTANCE_LEARNING_ALL].loading = true
      })
      .addCase(actionCreators.disLearningLessonAll.rejected, (state, action) => {
        state[LESSON_DISTANCE_LEARNING_ALL].loading = false
        state[LESSON_DISTANCE_LEARNING_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.disLearningLessonAll.fulfilled, (state, action) => {
        state[LESSON_DISTANCE_LEARNING_ALL].loading = false
        state[LESSON_DISTANCE_LEARNING_ALL].error = null
        state[LESSON_DISTANCE_LEARNING_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonAttendance.pending, state => {
        state[LESSON_ATTENDANCE].loading = true
      })
      .addCase(actionCreators.lessonAttendance.rejected, (state, action) => {
        state[LESSON_ATTENDANCE].loading = false
        state[LESSON_ATTENDANCE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonAttendance.fulfilled, (state, action) => {
        state[LESSON_ATTENDANCE].loading = false
        state[LESSON_ATTENDANCE].error = null
        state[LESSON_ATTENDANCE].data = action.payload
      })

    builder
      .addCase(actionCreators.lessonAttendanceGroup.pending, state => {
        state[LESSON_ATTENDANCE_GROUP].loading = true
      })
      .addCase(actionCreators.lessonAttendanceGroup.rejected, (state, action) => {
        state[LESSON_ATTENDANCE_GROUP].loading = false
        state[LESSON_ATTENDANCE_GROUP].error = action.payload as AxiosError
      })
      .addCase(actionCreators.lessonAttendanceGroup.fulfilled, (state, action) => {
        state[LESSON_ATTENDANCE_GROUP].loading = false
        state[LESSON_ATTENDANCE_GROUP].error = null
        state[LESSON_ATTENDANCE_GROUP].data = action.payload
      })

    builder.addCase(actionCreators.lessonAllClear, state => {
      state[LESSON_ALL] = defaultState()
    })

    builder.addCase(actionCreators.lessonAssessmentAllClear, state => {
      state[LESSON_ASSESSMENT_ALL] = defaultState()
    })

    builder.addCase(actionCreators.lessonAssessmentClear, state => {
      state[LESSON_ASSESSMENT] = defaultState()
    })

    builder.addCase(actionCreators.lessonAssessmentListClear, state => {
      state[LESSON_ASSESSMENT_LIST] = defaultState()
    })

    builder.addCase(actionCreators.lessonClear, state => {
      state[LESSON] = defaultState()
    })

    builder.addCase(actionCreators.lessonHomeworkUploadClear, state => {
      state[LESSON_HOMEWORK_UPLOAD] = defaultState()
    })

    builder.addCase(actionCreators.lessonListClear, state => {
      state[LESSON_LIST] = defaultState()
    })

    builder.addCase(actionCreators.lessonDownloadFilesClear, state => {
      state[LESSON_DOWNLOAD_FILES] = defaultState()
    })

    builder.addCase(actionCreators.disLearningLessonAllClear, state => {
      state[LESSON_DISTANCE_LEARNING_ALL] = defaultState()
    })

    builder.addCase(actionCreators.lessonAttendanceClear, state => {
      state[LESSON_ATTENDANCE] = defaultState()
    })

    builder.addCase(actionCreators.lessonAttendanceGroupClear, state => {
      state[LESSON_ATTENDANCE_GROUP] = defaultState()
    })
  },
})

export const { reducer: lessonsReducer } = lossonsSlice
